import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor() {}

  encrypt(field: any): string {
    if (field == null) return '';
    try {
      return CryptoJS.AES.encrypt(String(field), 'iIUsWtNZcf').toString();
    } catch {
      return '';
    }
  }

  decrypt(cypherStr: any): string {
    if (cypherStr == null || cypherStr === '') return '';
    try {
      const bytes = CryptoJS.AES.decrypt(
        cypherStr.toString(),
        'iIUsWtNZcf',
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }
}
